
import { Attribute, Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[matInput]',
    standalone: false
})
export class AutocompleteGroupDirective {

  @HostBinding('attr.autocomplete') auto;
  constructor(@Attribute('autocomplete') autocomplete: string) { 
    this.auto = autocomplete || 'off';
  }

}


